import { render } from "./AccountTerminated.vue?vue&type=template&id=48d56102&scoped=true&ts=true"
import script from "./AccountTerminated.vue?vue&type=script&lang=ts"
export * from "./AccountTerminated.vue?vue&type=script&lang=ts"

import "./AccountTerminated.vue?vue&type=style&index=0&id=48d56102&scoped=true&lang=scss"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d56102"]])

export default __exports__